import cn from 'classnames';
import { useTheme } from 'styled-components';

import { IConDefaultType } from '..';
import { EColorMap } from '../constants/colorMap';

export enum CloseIconVariant {
  DEFAULT = 'default',
  SMALL = 'small',
  DELETE = 'delete',
  CLEAR = 'clear',
  DELETE_DARK = 'delete_dark',
  DELETE_LIGHT = 'delete_light',
}

interface ICloseIconProps extends IConDefaultType {
  variant?: CloseIconVariant;
}

function CloseIcon({
  color,
  className,
  size = 24,
  rotate,
  flip,
  variant = CloseIconVariant.DEFAULT,
  style,
  onClick,
}: ICloseIconProps) {
  const theme = useTheme();

  return (
    <i
      onClick={onClick}
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
        ...style,
      }}
    >
      {variant === CloseIconVariant.DEFAULT && (
        <svg viewBox="0 0 24 24" style={{ width: size }} fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L19.7071 18.2929C20.0976 18.6834 20.0976 19.3166 19.7071 19.7071C19.3166 20.0976 18.6834 20.0976 18.2929 19.7071L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z"
            fill={color || EColorMap.gray_0}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.7071 4.29289C20.0976 4.68342 20.0976 5.31658 19.7071 5.70711L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L18.2929 4.29289C18.6834 3.90237 19.3166 3.90237 19.7071 4.29289Z"
            fill={color || EColorMap.gray_0}
          />
        </svg>
      )}
      {variant === CloseIconVariant.SMALL && (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.863231 0.859325C1.12358 0.598975 1.54569 0.598975 1.80604 0.859325L11.1394 10.1927C11.3997 10.453 11.3997 10.8751 11.1394 11.1355C10.879 11.3958 10.4569 11.3958 10.1966 11.1355L0.863231 1.80213C0.602881 1.54178 0.602881 1.11967 0.863231 0.859325Z"
            fill={color || EColorMap.gray_0}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.1394 0.859325C11.3997 1.11967 11.3997 1.54178 11.1394 1.80213L1.80604 11.1355C1.54569 11.3958 1.12358 11.3958 0.863231 11.1355C0.602881 10.8751 0.602881 10.453 0.863231 10.1927L10.1966 0.859325C10.4569 0.598975 10.879 0.598975 11.1394 0.859325Z"
            fill={color || EColorMap.gray_0}
          />
        </svg>
      )}
      {variant === CloseIconVariant.CLEAR && (
        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            opacity="0.5"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10 18C5.6 18 2 14.4 2 10C2 5.6 5.6 2 10 2C14.4 2 18 5.6 18 10C18 14.4 14.4 18 10 18ZM7.56569 6.43483C7.25327 6.12241 6.74673 6.12241 6.43431 6.43483C6.12189 6.74725 6.12189 7.25378 6.43431 7.5662L8.86885 10.0007L6.43439 12.4352C6.12198 12.7476 6.12198 13.2541 6.43439 13.5666C6.74681 13.879 7.25335 13.879 7.56577 13.5666L10.0002 11.1321L12.4342 13.5661C12.7466 13.8785 13.2532 13.8785 13.5656 13.5661C13.878 13.2537 13.878 12.7471 13.5656 12.4347L11.1316 10.0007L13.5657 7.56666C13.8781 7.25424 13.8781 6.74771 13.5657 6.43529C13.2532 6.12287 12.7467 6.12287 12.4343 6.43529L10.0002 8.86936L7.56569 6.43483Z"
            fill="#ADB0B8"
          />
        </svg>
      )}
      {variant === CloseIconVariant.DELETE && (
        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            opacity="0.5"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10 18C5.6 18 2 14.4 2 10C2 5.6 5.6 2 10 2C14.4 2 18 5.6 18 10C18 14.4 14.4 18 10 18Z"
            fill={color || theme.color.line.line_2}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.56564 6.43482C7.25322 6.1224 6.74669 6.1224 6.43427 6.43482C6.12185 6.74723 6.12185 7.25377 6.43427 7.56619L8.8688 10.0007L6.43435 12.4352C6.12193 12.7476 6.12193 13.2541 6.43435 13.5665C6.74677 13.879 7.2533 13.879 7.56572 13.5665L10.0002 11.1321L12.4342 13.5661C12.7466 13.8785 13.2531 13.8785 13.5655 13.5661C13.878 13.2537 13.878 12.7471 13.5655 12.4347L11.1315 10.0007L13.5656 7.56665C13.878 7.25423 13.878 6.7477 13.5656 6.43528C13.2532 6.12286 12.7467 6.12286 12.4342 6.43528L10.0002 8.86935L7.56564 6.43482Z"
            fill={theme.color.field.background}
          />
        </svg>
      )}
      {variant === CloseIconVariant.DELETE_DARK && (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path
            opacity="0.5"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10 18C5.6 18 2 14.4 2 10C2 5.6 5.6 2 10 2C14.4 2 18 5.6 18 10C18 14.4 14.4 18 10 18ZM7.56569 6.43483C7.25327 6.12241 6.74673 6.12241 6.43431 6.43483C6.12189 6.74725 6.12189 7.25378 6.43431 7.5662L8.86885 10.0007L6.43439 12.4352C6.12198 12.7476 6.12198 13.2541 6.43439 13.5666C6.74681 13.879 7.25335 13.879 7.56577 13.5666L10.0002 11.1321L12.4342 13.5661C12.7466 13.8785 13.2532 13.8785 13.5656 13.5661C13.878 13.2537 13.878 12.7471 13.5656 12.4347L11.1316 10.0007L13.5657 7.56666C13.8781 7.25424 13.8781 6.74771 13.5657 6.43529C13.2532 6.12287 12.7467 6.12287 12.4343 6.43529L10.0002 8.86936L7.56569 6.43483Z"
            fill="#676B8A"
          />
        </svg>
      )}
      {variant === CloseIconVariant.DELETE_LIGHT && (
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.5 18.0005C6.1 18.0005 2.5 14.4005 2.5 10.0005C2.5 5.60049 6.1 2.00049 10.5 2.00049C14.9 2.00049 18.5 5.60049 18.5 10.0005C18.5 14.4005 14.9 18.0005 10.5 18.0005Z"
            fill="#C4C6C9"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.0649 7.56588C14.3773 7.25346 14.3773 6.74693 14.0649 6.43451C13.7525 6.12209 13.2459 6.12209 12.9335 6.43451L10.4991 8.86891L8.0649 6.4347C7.75248 6.12228 7.24595 6.12228 6.93353 6.4347C6.62111 6.74712 6.62111 7.25365 6.93353 7.56607L9.36774 10.0003L6.93361 12.4344C6.62119 12.7468 6.62119 13.2534 6.93361 13.5658C7.24603 13.8782 7.75256 13.8782 8.06498 13.5658L10.4991 11.1316L12.9334 13.566C13.2458 13.8784 13.7524 13.8784 14.0648 13.566C14.3772 13.2535 14.3772 12.747 14.0648 12.4346L11.6305 10.0003L14.0649 7.56588Z"
            fill="white"
          />
        </svg>
      )}
    </i>
  );
}

export default CloseIcon;
